import { TASK_TYPE } from './task';

// patrol status
export const PATROL_STATUS = {
  NEW: { id: 'NEW', name: 'New' },
  IN_PROGRESS: { id: 'IN_PROGRESS', name: 'In-Progress' },
  RESOLVED_SUCCESSFUL: {
    id: 'RESOLVED_SUCCESSFUL',
    name: 'Completed',
  },
  RESOLVED_INCOMPLETE: {
    id: 'RESOLVED_INCOMPLETE',
    name: 'Incomplete',
  },
  RESOLVED_ABORTED: { id: 'RESOLVED_ABORTED', name: 'Aborted' },
};

export const PATROL_STATUS_OPTIONS = [
  PATROL_STATUS.NEW,
  PATROL_STATUS.IN_PROGRESS,
  PATROL_STATUS.RESOLVED_SUCCESSFUL,
  PATROL_STATUS.RESOLVED_INCOMPLETE,
  PATROL_STATUS.RESOLVED_ABORTED,
];

export const REPORTING_PATROL_STATUS_FILTERS = [
  {
    id: PATROL_STATUS.IN_PROGRESS.id,
    name: PATROL_STATUS.IN_PROGRESS.name,
  },
  {
    id: PATROL_STATUS.RESOLVED_SUCCESSFUL.id,
    name: PATROL_STATUS.RESOLVED_SUCCESSFUL.name,
  },
  {
    id: PATROL_STATUS.RESOLVED_INCOMPLETE.id,
    name: PATROL_STATUS.RESOLVED_INCOMPLETE.name,
  },
  {
    id: PATROL_STATUS.RESOLVED_ABORTED.id,
    name: PATROL_STATUS.RESOLVED_ABORTED.name,
  },
];

export const PATROL_STATUS_DEFAULT_FILTERS = [
  {
    id: PATROL_STATUS.NEW.id,
    name: PATROL_STATUS.NEW.name,
  },
  {
    id: PATROL_STATUS.IN_PROGRESS.id,
    name: PATROL_STATUS.IN_PROGRESS.name,
  },
  {
    id: PATROL_STATUS.RESOLVED_SUCCESSFUL.id,
    name: PATROL_STATUS.RESOLVED_SUCCESSFUL.name,
  },
  {
    id: PATROL_STATUS.RESOLVED_INCOMPLETE.id,
    name: PATROL_STATUS.RESOLVED_INCOMPLETE.name,
  },
  {
    id: PATROL_STATUS.RESOLVED_ABORTED.id,
    name: PATROL_STATUS.RESOLVED_ABORTED.name,
  },
];

export const PATROL_MAP_LINE = {
  strokeColor: '#bbbec0',
  strokeWeight: 5,
};

export const PATROL_EVIDENCE_DEFAULT_VALUES = {
  taskType: TASK_TYPE.PATROL_CHECKPOINT_TASK.id,
  taskImage: null,
  isTemplate: true,
  hidden: true,
};

export const PATROL_TYPE = {
  CHECKPOINT: { id: 'CHECKPOINT', allowTaskEvidence: true },
  WAYPOINT: { id: 'WAYPOINT', allowTaskEvidence: false },
};
